import { Dialog, Grow, Icon, IconButton } from '@mui/material'
import { red } from '@mui/material/colors';
import React from 'react'
import {makeStyles} from '@mui/styles'
import Iconify from '../../components/iconify';

const Transition = React.forwardRef(function Transition(props, ref) {return <Grow ref={ref} {...props} timeout={500} />;});

const useStyles = makeStyles(theme => ({
    paper:{
        borderRadius:32, 
        padding:theme.spacing(5),
        position:'relative',
        [theme.breakpoints.down('sm')]:{
            padding:theme.spacing(3),
            margin:8
        },
        
    },
    root:{

        //padding:40
    },
    icon:{
        color:'white',
        background:red[700],
        borderRadius:'50%',
        fontSize:54,
        padding:8
    },
    message:{
        paddingTop:16,
        paddingBottom:16,
        maxWidth:300
    },
    close_button:{
        position:'absolute', right:16, top:16
    }
}))

const SimpleModal = (props) => {

    const classes = useStyles()
    const {open, children, onClose, maxWidth, fullWidth, fullScreen, disabledCloseBtn} = props

    return(
        <Dialog open={open} maxWidth={maxWidth ? maxWidth : 'xs'} fullWidth={fullWidth !== undefined ? fullWidth : true} classes={{ paper: classes.paper }} className={classes.root}
        TransitionComponent={Transition} onClose={onClose} scroll='body' >
            <div className={classes.root}>
                {!disabledCloseBtn ? <IconButton className={classes.close_button} onClick={onClose} ><Iconify icon="ic:baseline-close" /></IconButton> : null}
                {children}
            </div>
        </Dialog>
    )
}

export default SimpleModal
